import { startOfDay } from "date-fns";

import { buildWorkspacesMapLayer, getRefreshBucketStart } from "@lib/logic";
import {
  getNodeInformationPerAreaByBuildingId,
  getWorkspaceOccupancyForBuildingAndFloorId,
  useAppSelector,
} from "@lib/store";
import { useRequiredContext } from "@lib/utils";

import { useFacilityMarkers } from "../../../organisms/hereAndNow/useFacilityMarkers";
import { HaNContext } from "../shell/HaNContext";
import { HaNMapStageContext, useHaNMapLayer } from "../shell/regions/HaNMapStageContext";
import { useConnectionDesks } from "./useConnectionDesks";

export const WorkspacesMap = () => {
  const { tab } = useRequiredContext(HaNContext);
  const { floorId } = useRequiredContext(HaNMapStageContext);

  if (tab !== "workspaces" || !floorId) return null;

  return <WorkspacesMapLayer floorId={floorId} />;
};

// Builds the tab's layer for the page's one map, which the map stage draws
const WorkspacesMapLayer = ({ floorId }: { floorId: string }) => {
  const { bucket, building, filterData } = useRequiredContext(HaNContext);
  const buildingId = building.buildingId ?? "";

  // The refresh bucket keeps "now" moving while the page is open
  const now = new Date(getRefreshBucketStart(bucket));

  const sensorData = useAppSelector(state => getWorkspaceOccupancyForBuildingAndFloorId(state, buildingId, floorId));
  const areaBookingStates = useAppSelector(state => {
    return getNodeInformationPerAreaByBuildingId(state, startOfDay(now).toISOString(), buildingId);
  });
  const connectionDesks = useConnectionDesks({ floorId, now });
  const facilityMarkers = useFacilityMarkers(buildingId, floorId);

  const layer = buildWorkspacesMapLayer({
    floorId,
    areas: filterData.workspaces.filteredData,
    sensorData,
    areaBookingStates,
    connectionDesks,
    facilityMarkers,
  });

  useHaNMapLayer(layer);

  return null;
};
